/**
 * The raw Ably message we get right from the Horse's mouth.
 */

const PROPERTY_UPDATE = 'PROPERTY_UPDATE';
export const CrmRealtimeUpdateMessageType = {
  [PROPERTY_UPDATE]: PROPERTY_UPDATE
};
// Helpers

export const mapRawAblyMessage = message => {
  switch (message.name) {
    case PROPERTY_UPDATE:
      {
        return {
          name: CrmRealtimeUpdateMessageType.PROPERTY_UPDATE,
          timestamp: message.timestamp,
          data: JSON.parse(message.data)
        };
      }
    default:
      {
        throw new Error(`Unknown message type: ${message.name}`);
      }
  }
};